module.exports = __webpack_public_path__ + "img/your-subscription-is-about-expire-3-th.97cfe3b.png";